import { jsx as u } from "react/jsx-runtime";
import { c as w } from "../../../clsx-OuTLNxxd.js";
const d = "_flex_k8zg6_29", h = "_wrap_k8zg6_67", x = "_nowrap_k8zg6_70", _ = {
  flex: d,
  "flex-row": "_flex-row_k8zg6_34",
  "flex-column": "_flex-column_k8zg6_37",
  "justify-start": "_justify-start_k8zg6_40",
  "justify-end": "_justify-end_k8zg6_43",
  "justify-center": "_justify-center_k8zg6_46",
  "justify-space-between": "_justify-space-between_k8zg6_49",
  "justify-space-around": "_justify-space-around_k8zg6_52",
  "align-start": "_align-start_k8zg6_55",
  "align-end": "_align-end_k8zg6_58",
  "align-center": "_align-center_k8zg6_61",
  "align-stretch": "_align-stretch_k8zg6_64",
  wrap: h,
  nowrap: x,
  "wrap-reverse": "_wrap-reverse_k8zg6_73",
  "is-full-width": "_is-full-width_k8zg6_79",
  "is-full-height": "_is-full-height_k8zg6_82",
  "flex-grow": "_flex-grow_k8zg6_85",
  "hide-on-mobile": "_hide-on-mobile_k8zg6_88",
  "gap-0": "_gap-0_k8zg6_96",
  "gap-1": "_gap-1_k8zg6_99",
  "gap-2": "_gap-2_k8zg6_102",
  "gap-3": "_gap-3_k8zg6_105",
  "gap-4": "_gap-4_k8zg6_108",
  "gap-5": "_gap-5_k8zg6_111",
  "gap-6": "_gap-6_k8zg6_114",
  "gap-7": "_gap-7_k8zg6_117",
  "gap-8": "_gap-8_k8zg6_120",
  "gap-9": "_gap-9_k8zg6_123",
  "gap-10": "_gap-10_k8zg6_126",
  "gap-11": "_gap-11_k8zg6_129",
  "gap-12": "_gap-12_k8zg6_132",
  "gap-14": "_gap-14_k8zg6_135",
  "gap-16": "_gap-16_k8zg6_138",
  "gap-18": "_gap-18_k8zg6_141",
  "gap-20": "_gap-20_k8zg6_144",
  "gap-24": "_gap-24_k8zg6_147",
  "gap-28": "_gap-28_k8zg6_150",
  "gap-32": "_gap-32_k8zg6_153",
  "gap-36": "_gap-36_k8zg6_156",
  "gap-40": "_gap-40_k8zg6_159",
  "gap-44": "_gap-44_k8zg6_162",
  "gap-48": "_gap-48_k8zg6_165",
  "gap-52": "_gap-52_k8zg6_168",
  "gap-56": "_gap-56_k8zg6_171",
  "gap-60": "_gap-60_k8zg6_174",
  "gap-64": "_gap-64_k8zg6_177",
  "gap-72": "_gap-72_k8zg6_180",
  "gap-80": "_gap-80_k8zg6_183",
  "gap-96": "_gap-96_k8zg6_186",
  "no-margin": "_no-margin_k8zg6_189",
  "dialog-overlay-show": "_dialog-overlay-show_k8zg6_1",
  "dialog-content-show": "_dialog-content-show_k8zg6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_k8zg6_1"
};
function j({
  children: a,
  direction: p = "row",
  justifyContent: e = "start",
  alignItems: l = "start",
  flexWrap: t = "wrap",
  className: s = "",
  isFullWidth: k = !1,
  isFullHeight: z = !1,
  gap: g,
  style: i,
  noMargin: n = !1,
  flexGrow: o = !1,
  hideOnMobile: r = !1,
  ...f
}) {
  const c = w(
    _.flex,
    _[`flex-${p}`],
    _[`justify-${e}`],
    _[`align-${l}`],
    _[t],
    k && _["is-full-width"],
    z && _["is-full-height"],
    g && _[`gap-${g}`],
    n && _["no-margin"],
    o && _["flex-grow"],
    r && _["hide-on-mobile"],
    s
  );
  return /* @__PURE__ */ u("div", { className: c, ...f, style: i, children: a });
}
export {
  j as Flex
};
